import Backdrop from './Backdrop';
import Icon from './Icon';
function Modal(props) {
  return (
    <>
      <div
        className={` ${
          props.show ? 'block' : 'hidden'
        } z-50 fixed top-10 h-[90vh] shadow-2xl left-[5%] right-[5%] overflow-y-auto`}
        style={props.style}
      >
        <div>{props.children}</div>
        {/* CLOSE BUTTON */}
        <div
          className='fixed p-2 text-white z-10000 cursor-pointer  right-[1rem] top-[1rem] bg-gray-400 rounded-full  hover:bg-red-700 shadow-md'
          onClick={props.close}
        >
          <Icon name='close' className='w-5 h-5 fill-white' />
        </div>
      </div>
      <Backdrop onClick={props.close} show={props.show} />
    </>
  );
}

export default Modal;
